export default (params) => ({
  trigger: {
    name: 'service_accessory_overlays.confirm_choice',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'wall_mount_selector_recommendations',
          'stacking_kit_overlay_recommendations',
        ],
      },
    },
    event: {
      name: 'confirm',
      params: {
        status: null,
      },
    },
  },
});
